import {
  roomAnyId,
  RoomAnyId,
  rtmpDestinationKey,
  RtmpDestinationKey,
  rtmpDestinationUrl,
  RtmpDestinationUrl
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class RtmpDestinationCreateRequestDTO extends BaseRequestDTO<RtmpDestinationCreateRequestDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    RtmpDestinationCreateRequestDTO.validationSchema()
  );

  constructor(value: RtmpDestinationCreateRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(
        RtmpDestinationCreateRequestDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["url", "key"],
      properties: {
        url: rtmpDestinationUrl,
        key: rtmpDestinationKey,
        roomId: roomAnyId
      },
      additionalProperties: false
    };
  }

  override toJSON(): object {
    return {
      type: "rtmp",
      destination: this.value
    };
  }
}

interface RtmpDestinationCreateRequestDTORaw {
  url: RtmpDestinationUrl;
  key: RtmpDestinationKey;
  roomId?: RoomAnyId;
}
